import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 mb-4 bg-white shadow-sm" }
const _hoisted_2 = { class: "card-header bg-light-subtle d-flex justify-content-between align-items-center py-3 px-4" }
const _hoisted_3 = {
  key: 0,
  class: "badge bg-success-subtle text-success fs-12 px-3 py-2"
}
const _hoisted_4 = {
  key: 1,
  class: "badge bg-warning-subtle text-warning fs-12 px-3 py-2"
}
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = {
  key: 0,
  class: "mb-4 p-3 rounded-3 bg-light border border-light-subtle"
}
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3" }
const _hoisted_8 = { class: "fw-bold text-primary mb-0" }
const _hoisted_9 = { class: "d-flex gap-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "row g-2 fs-13" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "fw-bold text-dark ms-1" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "fw-bold text-dark ms-1" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "fw-semibold text-dark ms-1" }
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mt-2 pt-2 border-top fs-12 text-muted" }
const _hoisted_23 = { class: "d-flex gap-3" }
const _hoisted_24 = { class: "text-dark ms-1" }
const _hoisted_25 = { class: "text-dark ms-1" }
const _hoisted_26 = { class: "text-dark ms-1" }
const _hoisted_27 = { class: "material-symbols-outlined fs-14" }
const _hoisted_28 = {
  key: 0,
  class: "mt-3 pt-3 border-top"
}
const _hoisted_29 = { class: "p-2 mb-3 bg-white rounded border" }
const _hoisted_30 = { class: "row g-2 fs-12 text-dark" }
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_36 = { class: "card-body p-3" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-4 mb-2" }
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "col-md-4 mb-2" }
const _hoisted_41 = { class: "col-md-4 mb-2" }
const _hoisted_42 = { class: "col-md-4 mb-2" }
const _hoisted_43 = { class: "col-md-4 mb-2" }
const _hoisted_44 = { class: "col-md-4 mb-2" }
const _hoisted_45 = { class: "col-md-4 mb-2" }
const _hoisted_46 = { class: "col-md-8 mb-2" }
const _hoisted_47 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_48 = { class: "card-header bg-light d-flex align-items-center justify-content-between py-2 px-3" }
const _hoisted_49 = { class: "card-body p-3" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-3 mb-2" }
const _hoisted_52 = { class: "col-md-3 mb-2" }
const _hoisted_53 = { class: "col-md-3 mb-2 d-flex align-items-center pt-3" }
const _hoisted_54 = { class: "form-check" }
const _hoisted_55 = { class: "col-md-3 mb-2 d-flex align-items-center pt-3" }
const _hoisted_56 = { class: "form-check" }
const _hoisted_57 = { class: "row mt-2 pt-2 border-top g-2 align-items-center" }
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "input-group input-group-sm" }
const _hoisted_60 = ["placeholder"]
const _hoisted_61 = {
  key: 1,
  class: "input-group-text fs-12"
}
const _hoisted_62 = { class: "col-md-6 d-flex justify-content-between align-items-center pt-3" }
const _hoisted_63 = { class: "fs-12 text-secondary" }
const _hoisted_64 = { class: "text-dark" }
const _hoisted_65 = { class: "fs-12 text-secondary" }
const _hoisted_66 = { class: "text-dark" }
const _hoisted_67 = { class: "card border rounded-3 mb-4 bg-light-subtle shadow-sm" }
const _hoisted_68 = { class: "card-body p-3 d-flex flex-wrap justify-content-between align-items-center gap-2" }
const _hoisted_69 = { class: "form-check d-flex align-items-center m-0" }
const _hoisted_70 = {
  key: 0,
  class: "badge bg-success-subtle text-success fs-11 px-2 py-1 border border-success-subtle d-inline-flex align-items-center gap-1"
}
const _hoisted_71 = {
  key: 1,
  class: "badge bg-secondary-subtle text-secondary fs-11 px-2 py-1 border border-secondary-subtle d-inline-flex align-items-center gap-1"
}
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_74 = { class: "card-header bg-light d-flex justify-content-between align-items-center py-2 px-3" }
const _hoisted_75 = { class: "d-flex align-items-center gap-2" }
const _hoisted_76 = { class: "badge bg-warning-subtle text-dark fs-11 ms-2" }
const _hoisted_77 = { class: "card-body p-3" }
const _hoisted_78 = {
  key: 0,
  class: "text-center py-3 text-muted fs-12 bg-light-subtle rounded border border-dashed"
}
const _hoisted_79 = { class: "mt-2" }
const _hoisted_80 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_81 = { class: "table table-sm table-bordered align-middle mb-0 fs-12" }
const _hoisted_82 = ["onUpdate:modelValue"]
const _hoisted_83 = ["onUpdate:modelValue"]
const _hoisted_84 = { class: "input-group input-group-sm" }
const _hoisted_85 = ["onUpdate:modelValue"]
const _hoisted_86 = ["onUpdate:modelValue"]
const _hoisted_87 = ["onUpdate:modelValue"]
const _hoisted_88 = ["onUpdate:modelValue"]
const _hoisted_89 = { class: "text-center" }
const _hoisted_90 = ["onClick"]
const _hoisted_91 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_92 = { class: "card-header bg-light d-flex align-items-center justify-content-between py-2 px-3" }
const _hoisted_93 = { class: "d-flex align-items-center gap-2" }
const _hoisted_94 = { class: "badge bg-primary-subtle text-primary fs-11" }
const _hoisted_95 = { class: "card-body p-3" }
const _hoisted_96 = {
  key: 0,
  class: "text-center py-3 text-muted fs-12 bg-light-subtle rounded border border-dashed"
}
const _hoisted_97 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_98 = { class: "table table-sm align-middle fs-12 mb-0" }
const _hoisted_99 = { class: "text-center fw-bold" }
const _hoisted_100 = ["onUpdate:modelValue"]
const _hoisted_101 = { class: "input-group input-group-sm" }
const _hoisted_102 = ["onUpdate:modelValue"]
const _hoisted_103 = ["onUpdate:modelValue"]
const _hoisted_104 = ["onUpdate:modelValue"]
const _hoisted_105 = { class: "text-center" }
const _hoisted_106 = ["onClick"]
const _hoisted_107 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_108 = { class: "card-header bg-light d-flex align-items-center justify-content-between py-2 px-3" }
const _hoisted_109 = { class: "badge bg-primary-subtle text-primary fs-11 d-inline-flex align-items-center gap-1" }
const _hoisted_110 = { class: "card-body p-3" }
const _hoisted_111 = { class: "row g-2" }
const _hoisted_112 = { class: "col-md-3" }
const _hoisted_113 = { class: "col-md-3" }
const _hoisted_114 = { class: "form-label fs-12 d-flex justify-content-between" }
const _hoisted_115 = {
  key: 0,
  class: "text-muted fs-10"
}
const _hoisted_116 = { class: "col-md-3" }
const _hoisted_117 = { class: "form-label fs-12 d-flex justify-content-between" }
const _hoisted_118 = {
  key: 0,
  class: "text-muted fs-10"
}
const _hoisted_119 = { class: "col-md-3" }
const _hoisted_120 = { class: "col-md-6 mt-2" }
const _hoisted_121 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_122 = { class: "card-body p-3" }
const _hoisted_123 = { class: "row" }
const _hoisted_124 = { class: "col-md-4 mb-2" }
const _hoisted_125 = { class: "col-md-4 mb-2" }
const _hoisted_126 = { class: "col-md-4 mb-2" }
const _hoisted_127 = { class: "col-md-3 mb-2" }
const _hoisted_128 = { class: "col-md-3 mb-2" }
const _hoisted_129 = { class: "col-md-3 mb-2" }
const _hoisted_130 = { class: "col-md-3 mb-2" }
const _hoisted_131 = { class: "card border rounded-3 mb-4 bg-light-subtle shadow-sm" }
const _hoisted_132 = { class: "card-body p-3 d-flex flex-wrap justify-content-between align-items-center gap-2" }
const _hoisted_133 = { class: "form-check d-flex align-items-center m-0" }
const _hoisted_134 = {
  key: 0,
  class: "badge bg-success-subtle text-success fs-11 px-2 py-1 border border-success-subtle d-inline-flex align-items-center gap-1"
}
const _hoisted_135 = {
  key: 1,
  class: "badge bg-secondary-subtle text-secondary fs-11 px-2 py-1 border border-secondary-subtle d-inline-flex align-items-center gap-1"
}
const _hoisted_136 = {
  key: 1,
  class: "card border rounded-3 mb-4 shadow-sm"
}
const _hoisted_137 = { class: "card-header bg-light d-flex align-items-center justify-content-between py-2 px-3" }
const _hoisted_138 = { class: "d-flex gap-2" }
const _hoisted_139 = { class: "card-body p-3" }
const _hoisted_140 = { class: "p-3 bg-light-subtle rounded border mb-3" }
const _hoisted_141 = { class: "row g-2" }
const _hoisted_142 = { class: "col-md-3" }
const _hoisted_143 = { class: "input-group input-group-sm" }
const _hoisted_144 = { class: "col-md-3" }
const _hoisted_145 = { class: "input-group input-group-sm" }
const _hoisted_146 = { class: "col-md-3" }
const _hoisted_147 = { class: "input-group input-group-sm" }
const _hoisted_148 = { class: "col-md-3" }
const _hoisted_149 = { class: "input-group input-group-sm" }
const _hoisted_150 = { class: "table-responsive" }
const _hoisted_151 = { class: "table table-sm align-middle fs-12 mb-0" }
const _hoisted_152 = { class: "text-center fw-bold" }
const _hoisted_153 = { class: "input-group input-group-sm justify-content-center" }
const _hoisted_154 = ["onUpdate:modelValue"]
const _hoisted_155 = ["onUpdate:modelValue"]
const _hoisted_156 = ["onUpdate:modelValue"]
const _hoisted_157 = { class: "input-group input-group-sm" }
const _hoisted_158 = ["onUpdate:modelValue"]
const _hoisted_159 = ["onUpdate:modelValue"]
const _hoisted_160 = ["onUpdate:modelValue"]
const _hoisted_161 = { class: "text-center" }
const _hoisted_162 = ["onClick"]
const _hoisted_163 = { key: 0 }
const _hoisted_164 = { class: "card border rounded-3 mb-4 shadow-sm" }
const _hoisted_165 = { class: "card-body p-3" }
const _hoisted_166 = { class: "row" }
const _hoisted_167 = { class: "col-md-4 mb-3" }
const _hoisted_168 = { class: "col-md-8 mb-3" }
const _hoisted_169 = { class: "col-12 mb-3" }
const _hoisted_170 = { class: "p-3 bg-light rounded-2 border" }
const _hoisted_171 = { class: "row g-2 fs-12 mb-2" }
const _hoisted_172 = { class: "col-md-4" }
const _hoisted_173 = { class: "form-check" }
const _hoisted_174 = { class: "col-md-4" }
const _hoisted_175 = { class: "form-check" }
const _hoisted_176 = { class: "col-md-4" }
const _hoisted_177 = { class: "form-check" }
const _hoisted_178 = { class: "col-md-4" }
const _hoisted_179 = { class: "form-check" }
const _hoisted_180 = { class: "col-md-4" }
const _hoisted_181 = { class: "form-check" }
const _hoisted_182 = { class: "col-md-4" }
const _hoisted_183 = { class: "form-check" }
const _hoisted_184 = { class: "row" }
const _hoisted_185 = { class: "col-12" }
const _hoisted_186 = { class: "col-md-6 mb-2" }
const _hoisted_187 = { class: "col-md-6 mb-2" }
const _hoisted_188 = { class: "col-12 mt-3" }
const _hoisted_189 = { class: "card bg-light-subtle border p-3 rounded-3" }
const _hoisted_190 = { class: "row g-3" }
const _hoisted_191 = { class: "col-md-4" }
const _hoisted_192 = { class: "col-md-4" }
const _hoisted_193 = { class: "col-md-4" }
const _hoisted_194 = ["value"]
const _hoisted_195 = { class: "col-md-6" }
const _hoisted_196 = { class: "col-md-6" }
const _hoisted_197 = {
  key: 0,
  class: "col-12 mt-1"
}
const _hoisted_198 = { class: "d-flex align-items-center gap-3 p-2 bg-white rounded border" }
const _hoisted_199 = ["src"]
const _hoisted_200 = { class: "col-12 mt-3" }
const _hoisted_201 = { class: "form-check" }
const _hoisted_202 = { class: "d-flex justify-content-end gap-2 mt-4" }
const _hoisted_203 = ["disabled"]
const _hoisted_204 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[64] || (_cache[64] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
        _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-22" }, "fact_check"),
        _createElementVNode("h5", { class: "mb-0 fs-15 fw-bold text-dark" }, "Protokol Terpadu Uji Similaritas & Deteksi AI (SOP RBN/SOP-RC/PAI/001)")
      ], -1)),
      (_ctx.protocol)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.protocol.protocol_number), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, " Belum Dibuat "))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.protocol)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "text-muted fs-12" }, "Nomor Protokol Resmi (SOP RBN/SOP-RC/PAI/001)", -1)),
                _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.protocol.protocol_number), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generatePdf && _ctx.generatePdf(...args))),
                  disabled: _ctx.generatingPdf,
                  class: "btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                }, [
                  (_ctx.generatingPdf)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                    : _createCommentVNode("", true),
                  _cache[66] || (_cache[66] = _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "picture_as_pdf", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.generatingPdf ? 'Membuat PDF...' : 'Regenerate PDF RC-PAI'), 1)
                ], 8, _hoisted_10),
                (_ctx.order.generated_protocol_pdf || _ctx.protocol.generated_pdf)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.getFileUrl(_ctx.protocol.generated_pdf || _ctx.order.generated_protocol_pdf),
                      target: "_blank",
                      class: "btn btn-sm btn-success d-flex align-items-center gap-1"
                    }, _cache[67] || (_cache[67] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "download", -1),
                      _createElementVNode("span", null, "Unduh Dokumen Resmi A4", -1)
                    ]), 8, _hoisted_12))
                  : _createCommentVNode("", true),
                (_ctx.protocol.verification?.verification_code)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: _ctx.getVerificationUrl(_ctx.protocol.verification.verification_code),
                      target: "_blank",
                      class: "btn btn-sm btn-info text-white d-flex align-items-center gap-1"
                    }, _cache[68] || (_cache[68] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "verified", -1),
                      _createElementVNode("span", null, "Cek Verifikasi Publik", -1)
                    ]), 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[69] || (_cache[69] = _createElementVNode("span", { class: "text-muted" }, "Similaritas:", -1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.protocol.similarity_overall_before) + "% → " + _toDisplayString(_ctx.protocol.similarity_overall_after) + "%", 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[70] || (_cache[70] = _createElementVNode("span", { class: "text-muted" }, "Deteksi AI:", -1)),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.protocol.ai_score_initial) + "% → " + _toDisplayString(_ctx.protocol.ai_score_final) + "%", 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[71] || (_cache[71] = _createElementVNode("span", { class: "text-muted" }, "Keputusan:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["badge ms-1", _ctx.protocol.overall_decision === 'MEMENUHI' ? 'bg-success' : 'bg-warning'])
                }, _toDisplayString(_ctx.protocol.overall_decision), 3)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[72] || (_cache[72] = _createElementVNode("span", { class: "text-muted" }, "Sumber Tertinggi:", -1)),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.protocol.highest_source_match) + "%", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", null, [
                  _cache[73] || (_cache[73] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle text-primary" }, "format_list_numbered", -1)),
                  _createElementVNode("strong", _hoisted_24, _toDisplayString((_ctx.protocol.primary_sources || _ctx.protocol.primarySources || []).length), 1),
                  _cache[74] || (_cache[74] = _createTextVNode(" Primary Sources "))
                ]),
                _createElementVNode("div", null, [
                  _cache[75] || (_cache[75] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle text-warning" }, "rule", -1)),
                  _createElementVNode("strong", _hoisted_25, _toDisplayString((_ctx.protocol.manual_exclusions || _ctx.protocol.manualExclusions || []).length), 1),
                  _cache[76] || (_cache[76] = _createTextVNode(" Excluded "))
                ]),
                _createElementVNode("div", null, [
                  _cache[77] || (_cache[77] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle text-info" }, "view_agenda", -1)),
                  _createElementVNode("strong", _hoisted_26, _toDisplayString((_ctx.protocol.section_reviews || _ctx.protocol.sectionReviews || []).length), 1),
                  _cache[78] || (_cache[78] = _createTextVNode(" Bagian AI Terpetakan "))
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-xs btn-outline-secondary fs-11 py-1 px-2 d-flex align-items-center gap-1",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetailedOverview = !_ctx.showDetailedOverview))
              }, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.showDetailedOverview ? 'expand_less' : 'expand_more'), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.showDetailedOverview ? 'Tutup Rincian' : 'Lihat Rincian Output SOP'), 1)
              ])
            ]),
            (_ctx.showDetailedOverview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[87] || (_cache[87] = _createElementVNode("div", { class: "fw-bold fs-12 text-secondary mb-2" }, "Parameter Standar & Pengaturan (SOP RC-PAI):", -1)),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _cache[79] || (_cache[79] = _createElementVNode("span", { class: "text-muted" }, "Repository:", -1)),
                        _cache[80] || (_cache[80] = _createTextVNode()),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.protocol.repository_setting || 'No repository'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[81] || (_cache[81] = _createElementVNode("span", { class: "text-muted" }, "Batas Maks. Total:", -1)),
                        _cache[82] || (_cache[82] = _createTextVNode()),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.protocol.applied_max_overall) + "%", 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _cache[83] || (_cache[83] = _createElementVNode("span", { class: "text-muted" }, "Batas Sumber Tunggal:", -1)),
                        _cache[84] || (_cache[84] = _createTextVNode()),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.protocol.applied_max_single_source) + "%", 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _cache[85] || (_cache[85] = _createElementVNode("span", { class: "text-muted" }, "Ambang Batas AI:", -1)),
                        _cache[86] || (_cache[86] = _createTextVNode()),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.protocol.ai_threshold) + "%", 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[63] || (_cache[63] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveProtocol && _ctx.saveProtocol(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_35, [
          _cache[100] || (_cache[100] = _createElementVNode("div", { class: "card-header bg-light d-flex align-items-center gap-2 py-2 px-3" }, [
            _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "badge"),
            _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "1. Identitas Pemeriksaan & Klasifikasi Dokumen")
          ], -1)),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _cache[89] || (_cache[89] = _createElementVNode("label", { class: "form-label fs-12" }, "Profil Acuan", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.profile_id) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onProfileChange && _ctx.onProfileChange(...args)))
                }, [
                  _cache[88] || (_cache[88] = _createElementVNode("option", { value: null }, "-- Custom / Bebas --", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profiles, (p) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: p.id,
                      value: p.id
                    }, _toDisplayString(p.service_classification) + " (" + _toDisplayString(p.profile_name) + ") ", 9, _hoisted_39))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.form.profile_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[91] || (_cache[91] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Klasifikasi Layanan "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.service_classification) = $event)),
                  required: ""
                }, _cache[90] || (_cache[90] = [
                  _createStaticVNode("<option value=\"JAD Dosen\" data-v-6c17bcc0>JAD Dosen</option><option value=\"Artikel Jurnal\" data-v-6c17bcc0>Artikel Jurnal</option><option value=\"Skripsi/Tesis/Disertasi\" data-v-6c17bcc0>Skripsi/Tesis/Disertasi</option><option value=\"Proposal\" data-v-6c17bcc0>Proposal</option><option value=\"Laporan\" data-v-6c17bcc0>Laporan</option><option value=\"Lainnya\" data-v-6c17bcc0>Lainnya</option>", 6)
                ]), 512), [
                  [_vModelSelect, _ctx.form.service_classification]
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[93] || (_cache[93] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Versi Naskah "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.manuscript_version) = $event)),
                  required: ""
                }, _cache[92] || (_cache[92] = [
                  _createElementVNode("option", { value: "Draft Awal" }, "Draft Awal", -1),
                  _createElementVNode("option", { value: "Revisi 1" }, "Revisi 1", -1),
                  _createElementVNode("option", { value: "Revisi 2" }, "Revisi 2", -1),
                  _createElementVNode("option", { value: "Naskah Final" }, "Naskah Final", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.manuscript_version]
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[94] || (_cache[94] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Aplikasi / Software Pemeriksa "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.tool_name) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.tool_name]
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _cache[96] || (_cache[96] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Repository Setting "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.repository_setting) = $event)),
                  required: ""
                }, _cache[95] || (_cache[95] = [
                  _createElementVNode("option", { value: "No repository" }, "No repository (Standard RayaCheck)", -1),
                  _createElementVNode("option", { value: "Standard repository" }, "Standard repository", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.repository_setting]
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _cache[97] || (_cache[97] = _createElementVNode("label", { class: "form-label fs-12" }, "Report / Submission ID", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.report_submission_id) = $event)),
                  placeholder: "cth: 2198472918"
                }, null, 512), [
                  [_vModelText, _ctx.form.report_submission_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[98] || (_cache[98] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Tanggal Pemeriksaan "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.report_date) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.report_date]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _cache[99] || (_cache[99] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("File Hash (SHA-256) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm font-monospace fs-11",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.file_hash_sha256) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.file_hash_sha256]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _cache[102] || (_cache[102] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
              _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "settings_suggest"),
              _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "2. Parameter & Batas Toleransi Similaritas")
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.describeSources = !_ctx.describeSources)),
              class: "btn btn-xs btn-outline-warning text-dark fs-12 py-1 px-2 d-inline-flex align-items-center gap-1"
            }, [
              _cache[101] || (_cache[101] = _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "rule", -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.describeSources ? 'Tutup Rincian Sumber' : 'Kelola Sumber & Exclude'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _cache[103] || (_cache[103] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Maks. Total Similaritas (%) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.applied_max_overall) = $event)),
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.applied_max_overall,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _cache[104] || (_cache[104] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Maks. Sumber Tunggal (%) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.applied_max_single_source) = $event)),
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.applied_max_single_source,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.applied_exclude_biblio) = $event)),
                    id: "paiExBib"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.applied_exclude_biblio]
                  ]),
                  _cache[105] || (_cache[105] = _createElementVNode("label", {
                    class: "form-check-label fs-12",
                    for: "paiExBib"
                  }, "Exclude Bibliography", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.applied_exclude_quotes) = $event)),
                    id: "paiExQuotes"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.applied_exclude_quotes]
                  ]),
                  _cache[106] || (_cache[106] = _createElementVNode("label", {
                    class: "form-check-label fs-12",
                    for: "paiExQuotes"
                  }, "Exclude Quotes", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _cache[108] || (_cache[108] = _createElementVNode("label", { class: "form-label fs-12 mb-1" }, "Filter Exclude Small Matches", -1)),
                _createElementVNode("div", _hoisted_59, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-sm",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.small_matches_mode) = $event))
                  }, _cache[107] || (_cache[107] = [
                    _createElementVNode("option", { value: "none" }, "Tidak / None", -1),
                    _createElementVNode("option", { value: "words" }, "Words (Jumlah Kata)", -1),
                    _createElementVNode("option", { value: "percentage" }, "Percentage (%)", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.form.small_matches_mode]
                  ]),
                  (_ctx.form.small_matches_mode !== 'none')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "number",
                        min: "1",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.small_matches_value) = $event)),
                        placeholder: _ctx.form.small_matches_mode === 'words' ? 'cth: 8' : 'cth: 1'
                      }, null, 8, _hoisted_60)), [
                        [
                          _vModelText,
                          _ctx.form.small_matches_value,
                          void 0,
                          { number: true }
                        ]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.form.small_matches_mode !== 'none')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.form.small_matches_mode === 'words' ? 'kata' : '%'), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("span", _hoisted_63, [
                  _cache[109] || (_cache[109] = _createTextVNode(" Manual Source Exclusion: ")),
                  _createElementVNode("strong", _hoisted_64, _toDisplayString(_ctx.form.manual_exclusions.length) + " sumber dicatat", 1)
                ]),
                _createElementVNode("span", _hoisted_65, [
                  _cache[110] || (_cache[110] = _createTextVNode(" Sumber Primer: ")),
                  _createElementVNode("strong", _hoisted_66, _toDisplayString(_ctx.form.primary_sources.length) + " sumber", 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input mt-0",
                type: "checkbox",
                id: "describeSourcesCheck",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.describeSources) = $event)),
                style: {"cursor":"pointer","width":"1.25em","height":"1.25em"}
              }, null, 512), [
                [_vModelCheckbox, _ctx.describeSources]
              ]),
              _cache[111] || (_cache[111] = _createElementVNode("label", {
                class: "form-check-label fw-bold text-dark fs-13 ms-2 mb-0",
                for: "describeSourcesCheck",
                style: {"cursor":"pointer"}
              }, " Deskripsikan ", -1)),
              _cache[112] || (_cache[112] = _createElementVNode("span", { class: "text-muted fs-12 ms-2" }, " (Centang untuk membuka form & tabel rincian Manual Source Exclusion dan Primary Sources jika diperlukan) ", -1))
            ]),
            _createElementVNode("div", null, [
              (_ctx.describeSources)
                ? (_openBlock(), _createElementBlock("span", _hoisted_70, [
                    _cache[113] || (_cache[113] = _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "visibility", -1)),
                    _createElementVNode("span", null, "Form & Tabel Terbuka (" + _toDisplayString(_ctx.form.manual_exclusions.length) + " Exclude, " + _toDisplayString(_ctx.form.primary_sources.length) + " Primary)", 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_71, _cache[114] || (_cache[114] = [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "visibility_off", -1),
                    _createElementVNode("span", null, "Default: Tertutup (Tidak Wajib)", -1)
                  ])))
            ])
          ])
        ]),
        (_ctx.describeSources)
          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _cache[116] || (_cache[116] = _createElementVNode("span", { class: "material-symbols-outlined text-warning fs-18" }, "rule", -1)),
                    _createElementVNode("div", null, [
                      _cache[115] || (_cache[115] = _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "Manual Source Exclusion (Log Eksklusi Manual Sumber)", -1)),
                      _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.form.manual_exclusions.length) + " Sumber Dieksklusi", 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.addManualExclusion && _ctx.addManualExclusion(...args))),
                    class: "btn btn-xs btn-warning text-dark d-flex align-items-center gap-1 py-1 px-2 fs-12 fw-medium shadow-sm"
                  }, _cache[117] || (_cache[117] = [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "add", -1),
                    _createElementVNode("span", null, "Tambah Manual Source Exclusion", -1)
                  ]))
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _cache[126] || (_cache[126] = _createElementVNode("p", { class: "fs-12 text-muted mb-2" }, [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle text-primary" }, "info"),
                    _createTextVNode(" Sesuai SOP, jika pemeriksa mengecualikan kecocokan tertentu (seperti publikasi/preprint milik penulis sendiri, repository institusi, atau template resmi), cantumkan rincian dan alasannya demi audit kepatuhan integritas akademik. ")
                  ], -1)),
                  (_ctx.form.manual_exclusions.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        _cache[119] || (_cache[119] = _createElementVNode("span", { class: "material-symbols-outlined fs-24 d-block mb-1 text-secondary" }, "verified_user", -1)),
                        _cache[120] || (_cache[120] = _createTextVNode(" Tidak ada sumber yang dieksklusi secara manual (Pemeriksaan mengikuti pengaturan filter standar). ")),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addManualExclusion && _ctx.addManualExclusion(...args))),
                            class: "btn btn-xs btn-outline-warning text-dark fs-12 py-1 px-2"
                          }, _cache[118] || (_cache[118] = [
                            _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle" }, "add", -1),
                            _createTextVNode(" Tambah Manual Source Exclusion ")
                          ]))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                        _createElementVNode("table", _hoisted_81, [
                          _cache[125] || (_cache[125] = _createElementVNode("thead", { class: "table-light" }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { style: {"width":"27%"} }, "Sumber / Dokumen / URL"),
                              _createElementVNode("th", { style: {"width":"14%"} }, "Tipe Sumber"),
                              _createElementVNode("th", {
                                style: {"width":"12%"},
                                class: "text-center"
                              }, "Match Sblm Exclude (%)"),
                              _createElementVNode("th", { style: {"width":"21%"} }, "Alasan Justifikasi Akademik"),
                              _createElementVNode("th", { style: {"width":"11%"} }, "Petugas"),
                              _createElementVNode("th", { style: {"width":"11%"} }, "Waktu Exclude"),
                              _createElementVNode("th", {
                                style: {"width":"4%"},
                                class: "text-center"
                              }, "Aksi")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.manual_exclusions, (exc, idx) => {
                              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control form-control-sm",
                                    "onUpdate:modelValue": ($event: any) => ((exc.source_title_url) = $event),
                                    placeholder: "cth: Preprint Penulis di ResearchGate"
                                  }, null, 8, _hoisted_82), [
                                    [_vModelText, exc.source_title_url]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-sm",
                                    "onUpdate:modelValue": ($event: any) => ((exc.source_type) = $event)
                                  }, _cache[121] || (_cache[121] = [
                                    _createElementVNode("option", { value: "Self-match" }, "Self-match", -1),
                                    _createElementVNode("option", { value: "Bibliografi" }, "Bibliografi", -1),
                                    _createElementVNode("option", { value: "Quote" }, "Quote", -1),
                                    _createElementVNode("option", { value: "Lainnya" }, "Lainnya", -1)
                                  ]), 8, _hoisted_83), [
                                    [_vModelSelect, exc.source_type]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_84, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      step: "0.1",
                                      class: "form-control form-control-sm text-center",
                                      "onUpdate:modelValue": ($event: any) => ((exc.match_before) = $event)
                                    }, null, 8, _hoisted_85), [
                                      [
                                        _vModelText,
                                        exc.match_before,
                                        void 0,
                                        { number: true }
                                      ]
                                    ]),
                                    _cache[122] || (_cache[122] = _createElementVNode("span", { class: "input-group-text px-1" }, "%", -1))
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control form-control-sm",
                                    "onUpdate:modelValue": ($event: any) => ((exc.exclusion_reason) = $event),
                                    placeholder: "cth: Publikasi skripsi penulis sendiri yang sudah terbit"
                                  }, null, 8, _hoisted_86), [
                                    [_vModelText, exc.exclusion_reason]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-sm",
                                    "onUpdate:modelValue": ($event: any) => ((exc.authorized_by) = $event)
                                  }, _cache[123] || (_cache[123] = [
                                    _createElementVNode("option", { value: "Pemeriksa" }, "Pemeriksa", -1),
                                    _createElementVNode("option", { value: "QC" }, "QC", -1)
                                  ]), 8, _hoisted_87), [
                                    [_vModelSelect, exc.authorized_by]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control form-control-sm text-center fs-11",
                                    "onUpdate:modelValue": ($event: any) => ((exc.excluded_at) = $event),
                                    placeholder: "YYYY-MM-DD HH:mm:ss"
                                  }, null, 8, _hoisted_88), [
                                    [_vModelText, exc.excluded_at]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_89, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.removeManualExclusion(idx)),
                                    class: "btn btn-sm btn-outline-danger p-1 border-0",
                                    title: "Hapus Manual Exclusion"
                                  }, _cache[124] || (_cache[124] = [
                                    _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "delete", -1)
                                  ]), 8, _hoisted_90)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _cache[127] || (_cache[127] = _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "list_alt", -1)),
                    _cache[128] || (_cache[128] = _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "Daftar Sumber Similaritas Utama (Primary Sources)", -1)),
                    _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.form.primary_sources.length) + " Sumber", 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.addPrimarySource && _ctx.addPrimarySource(...args))),
                    class: "btn btn-xs btn-primary d-flex align-items-center gap-1"
                  }, _cache[129] || (_cache[129] = [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "add", -1),
                    _createElementVNode("span", null, "Tambah Sumber", -1)
                  ]))
                ]),
                _createElementVNode("div", _hoisted_95, [
                  (_ctx.form.primary_sources.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, _cache[130] || (_cache[130] = [
                        _createElementVNode("span", { class: "material-symbols-outlined fs-24 d-block mb-1 text-secondary" }, "menu_book", -1),
                        _createTextVNode(" Belum ada sumber primer yang dicatat. Klik "),
                        _createElementVNode("strong", null, "\"Tambah Sumber\"", -1),
                        _createTextVNode(" untuk mencatat sumber kecocokan utama. ")
                      ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_97, [
                        _createElementVNode("table", _hoisted_98, [
                          _cache[134] || (_cache[134] = _createElementVNode("thead", { class: "table-light" }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", {
                                style: {"width":"5%"},
                                class: "text-center"
                              }, "#"),
                              _createElementVNode("th", { style: {"width":"45%"} }, "Nama / Domain Sumber"),
                              _createElementVNode("th", {
                                style: {"width":"15%"},
                                class: "text-center"
                              }, "Match (%)"),
                              _createElementVNode("th", { style: {"width":"15%"} }, "Status"),
                              _createElementVNode("th", { style: {"width":"15%"} }, "Catatan"),
                              _createElementVNode("th", {
                                style: {"width":"5%"},
                                class: "text-center"
                              }, "Hapus")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.primary_sources, (src, idx) => {
                              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                _createElementVNode("td", _hoisted_99, _toDisplayString(src.source_rank), 1),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control form-control-sm",
                                    "onUpdate:modelValue": ($event: any) => ((src.source_name) = $event),
                                    placeholder: "cth: repository.ugm.ac.id"
                                  }, null, 8, _hoisted_100), [
                                    [_vModelText, src.source_name]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_101, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      step: "0.1",
                                      class: "form-control form-control-sm text-center",
                                      "onUpdate:modelValue": ($event: any) => ((src.match_percentage) = $event),
                                      onInput: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.recalcSources && _ctx.recalcSources(...args)))
                                    }, null, 40, _hoisted_102), [
                                      [
                                        _vModelText,
                                        src.match_percentage,
                                        void 0,
                                        { number: true }
                                      ]
                                    ]),
                                    _cache[131] || (_cache[131] = _createElementVNode("span", { class: "input-group-text px-1" }, "%", -1))
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select form-select-sm",
                                    "onUpdate:modelValue": ($event: any) => ((src.status) = $event)
                                  }, _cache[132] || (_cache[132] = [
                                    _createElementVNode("option", { value: "Wajar" }, "Wajar", -1),
                                    _createElementVNode("option", { value: "Perlu revisi" }, "Perlu revisi", -1),
                                    _createElementVNode("option", { value: "Klarifikasi" }, "Klarifikasi", -1)
                                  ]), 8, _hoisted_103), [
                                    [_vModelSelect, src.status]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control form-control-sm",
                                    "onUpdate:modelValue": ($event: any) => ((src.examiner_notes) = $event),
                                    placeholder: "Catatan..."
                                  }, null, 8, _hoisted_104), [
                                    [_vModelText, src.examiner_notes]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_105, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.removePrimarySource(idx)),
                                    class: "btn btn-sm btn-outline-danger p-1 border-0"
                                  }, _cache[133] || (_cache[133] = [
                                    _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "delete", -1)
                                  ]), 8, _hoisted_106)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _cache[136] || (_cache[136] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
              _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "analytics"),
              _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "3. Hasil Evaluasi Similaritas Teks")
            ], -1)),
            _createElementVNode("span", _hoisted_109, [
              _cache[135] || (_cache[135] = _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "auto_awesome", -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.describeSources && _ctx.form.primary_sources.length > 0 ? 'Auto-Kalkulasi dari Sumber Primer' : 'Input Manual / Bebas'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("div", _hoisted_112, [
                _cache[137] || (_cache[137] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Similaritas Awal (%) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.similarity_overall_before) = $event)),
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.similarity_overall_before,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("label", _hoisted_114, [
                  _cache[138] || (_cache[138] = _createElementVNode("span", null, [
                    _createTextVNode("Similaritas Akhir (%) "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  (_ctx.describeSources && _ctx.form.primary_sources.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_115, "(Total Sumber)"))
                    : _createCommentVNode("", true)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.similarity_overall_after) = $event)),
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.similarity_overall_after,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("label", _hoisted_117, [
                  _cache[139] || (_cache[139] = _createElementVNode("span", null, [
                    _createTextVNode("Sumber Tertinggi (%) "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  (_ctx.describeSources && _ctx.form.primary_sources.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_118, "(Maks Sumber)"))
                    : _createCommentVNode("", true)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.highest_source_match) = $event)),
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.highest_source_match,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_119, [
                _cache[140] || (_cache[140] = _createElementVNode("label", { class: "form-label fs-12" }, "Nama Sumber Tertinggi", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.highest_source_name) = $event)),
                  placeholder: "cth: repository.ugm.ac.id"
                }, null, 512), [
                  [_vModelText, _ctx.form.highest_source_name]
                ])
              ]),
              _createElementVNode("div", _hoisted_120, [
                _cache[142] || (_cache[142] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Status Uji Similaritas "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.similarity_result_status) = $event)),
                  required: ""
                }, _cache[141] || (_cache[141] = [
                  _createElementVNode("option", { value: "Memenuhi" }, "Memenuhi", -1),
                  _createElementVNode("option", { value: "Perlu revisi" }, "Perlu revisi", -1),
                  _createElementVNode("option", { value: "Perlu klarifikasi" }, "Perlu klarifikasi", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.similarity_result_status]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_121, [
          _cache[152] || (_cache[152] = _createElementVNode("div", { class: "card-header bg-light d-flex align-items-center gap-2 py-2 px-3" }, [
            _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "smart_toy"),
            _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "4. Metrik & Parameter Deteksi AI")
          ], -1)),
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _cache[143] || (_cache[143] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Nama Detektor AI "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.ai_detector_name) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.ai_detector_name]
                ])
              ]),
              _createElementVNode("div", _hoisted_125, [
                _cache[144] || (_cache[144] = _createElementVNode("label", { class: "form-label fs-12" }, "Versi Engine AI", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.ai_detector_version) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.form.ai_detector_version]
                ])
              ]),
              _createElementVNode("div", _hoisted_126, [
                _cache[145] || (_cache[145] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Ambang Batas AI Toleransi (%) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.ai_threshold) = $event)),
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.ai_threshold,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_127, [
                _cache[146] || (_cache[146] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Skor AI Awal (%) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.ai_score_initial) = $event)),
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.ai_score_initial,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_128, [
                _cache[147] || (_cache[147] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Skor AI Akhir (%) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.ai_score_final) = $event)),
                  onInput: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.recalcAiDecision && _ctx.recalcAiDecision(...args))),
                  required: ""
                }, null, 544), [
                  [
                    _vModelText,
                    _ctx.form.ai_score_final,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_129, [
                _cache[149] || (_cache[149] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Zona Risiko AI "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.ai_internal_zone) = $event)),
                  required: ""
                }, _cache[148] || (_cache[148] = [
                  _createElementVNode("option", { value: "Zona Hijau / Aman" }, "Zona Hijau / Aman", -1),
                  _createElementVNode("option", { value: "Zona Perhatian" }, "Zona Perhatian", -1),
                  _createElementVNode("option", { value: "Zona Kritis" }, "Zona Kritis", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.ai_internal_zone]
                ])
              ]),
              _createElementVNode("div", _hoisted_130, [
                _cache[151] || (_cache[151] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Status Kode AI "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.ai_status_code) = $event)),
                  required: ""
                }, _cache[150] || (_cache[150] = [
                  _createElementVNode("option", { value: "PASS" }, "PASS (Lolos)", -1),
                  _createElementVNode("option", { value: "REVISE" }, "REVISE (Perlu Revisi)", -1),
                  _createElementVNode("option", { value: "NEED_REVIEW" }, "NEED_REVIEW (Perlu Klarifikasi)", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.ai_status_code]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_131, [
          _createElementVNode("div", _hoisted_132, [
            _createElementVNode("div", _hoisted_133, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input mt-0",
                type: "checkbox",
                id: "describeBlocksCheck",
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.describeBlocks) = $event)),
                onChange: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.onDescribeBlocksChange && _ctx.onDescribeBlocksChange(...args))),
                style: {"cursor":"pointer","width":"1.25em","height":"1.25em"}
              }, null, 544), [
                [_vModelCheckbox, _ctx.describeBlocks]
              ]),
              _cache[153] || (_cache[153] = _createElementVNode("label", {
                class: "form-check-label fw-bold text-dark fs-13 ms-2 mb-0",
                for: "describeBlocksCheck",
                style: {"cursor":"pointer"}
              }, " Deskripsikan Komposisi Konten & Rincian Blok Teks AI ", -1)),
              _cache[154] || (_cache[154] = _createElementVNode("span", { class: "text-muted fs-12 ms-2" }, " (Centang jika ingin merinci diagram komposisi konten dan blok teks deteksi AI Drillbit. Opsional) ", -1))
            ]),
            _createElementVNode("div", null, [
              (_ctx.describeBlocks)
                ? (_openBlock(), _createElementBlock("span", _hoisted_134, [
                    _cache[155] || (_cache[155] = _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "visibility", -1)),
                    _createElementVNode("span", null, "Aktif (" + _toDisplayString(_ctx.form.section_reviews.length) + " Blok Teks)", 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_135, _cache[156] || (_cache[156] = [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "visibility_off", -1),
                    _createElementVNode("span", null, "Default: Tidak Dijabarkan (Opsional)", -1)
                  ])))
            ])
          ])
        ]),
        (_ctx.describeBlocks)
          ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
              _createElementVNode("div", _hoisted_137, [
                _cache[159] || (_cache[159] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
                  _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "pie_chart"),
                  _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "5. Analisis Komposisi Konten & Deteksi AI Berbasis Blok (Drillbit Engine)")
                ], -1)),
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.autoCalcComposition && _ctx.autoCalcComposition(...args))),
                    class: "btn btn-xs btn-outline-secondary d-flex align-items-center gap-1 fs-11"
                  }, _cache[157] || (_cache[157] = [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "calculate", -1),
                    _createElementVNode("span", null, "Hitung Komposisi Otomatis", -1)
                  ])),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.addSectionReview && _ctx.addSectionReview(...args))),
                    class: "btn btn-xs btn-primary d-flex align-items-center gap-1"
                  }, _cache[158] || (_cache[158] = [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "add", -1),
                    _createElementVNode("span", null, "Tambah Blok", -1)
                  ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_139, [
                _createElementVNode("div", _hoisted_140, [
                  _cache[168] || (_cache[168] = _createElementVNode("div", { class: "fs-12 fw-bold text-dark mb-2 d-flex align-items-center gap-1" }, [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-16 text-primary" }, "donut_large"),
                    _createElementVNode("span", null, "Komposisi Konten (Content Composition)")
                  ], -1)),
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      _cache[161] || (_cache[161] = _createElementVNode("label", { class: "form-label fs-12 mb-1" }, [
                        _createTextVNode("Human Written (%) "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_143, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          step: "0.1",
                          class: "form-control form-control-sm text-center fw-bold text-success",
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.ai_human_written_pct) = $event)),
                          required: ""
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.form.ai_human_written_pct,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _cache[160] || (_cache[160] = _createElementVNode("span", { class: "input-group-text" }, "%", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_144, [
                      _cache[163] || (_cache[163] = _createElementVNode("label", { class: "form-label fs-12 mb-1" }, [
                        _createTextVNode("AI Text Content (%) "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_145, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          step: "0.1",
                          class: _normalizeClass(["form-control form-control-sm text-center fw-bold", Number(_ctx.form.ai_score_final) <= Number(_ctx.form.ai_threshold) ? 'text-success' : 'text-danger']),
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form.ai_score_final) = $event)),
                          onInput: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.recalcAiDecision && _ctx.recalcAiDecision(...args))),
                          required: ""
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.form.ai_score_final,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _cache[162] || (_cache[162] = _createElementVNode("span", { class: "input-group-text" }, "%", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_146, [
                      _cache[165] || (_cache[165] = _createElementVNode("label", { class: "form-label fs-12 mb-1" }, "Excluded Content (%)", -1)),
                      _createElementVNode("div", _hoisted_147, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          step: "0.1",
                          class: "form-control form-control-sm text-center",
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.ai_excluded_pct) = $event)),
                          placeholder: "0"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.form.ai_excluded_pct,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _cache[164] || (_cache[164] = _createElementVNode("span", { class: "input-group-text" }, "%", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_148, [
                      _cache[167] || (_cache[167] = _createElementVNode("label", { class: "form-label fs-12 mb-1" }, "Total Matched Words", -1)),
                      _createElementVNode("div", _hoisted_149, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control form-control-sm text-center",
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.ai_matched_words) = $event)),
                          placeholder: "cth: 1152"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.form.ai_matched_words,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _cache[166] || (_cache[166] = _createElementVNode("span", { class: "input-group-text" }, "kata", -1))
                      ])
                    ])
                  ]),
                  _cache[169] || (_cache[169] = _createElementVNode("div", { class: "text-muted fs-11 mt-1 fst-italic" }, " * Komposisi di atas sesuai dengan diagram persentase Drillbit AI: Human Written + AI Text + Excluded = 100%. ", -1))
                ]),
                _cache[176] || (_cache[176] = _createElementVNode("div", { class: "fs-12 fw-bold text-dark mb-2 d-flex align-items-center gap-1" }, [
                  _createElementVNode("span", { class: "material-symbols-outlined fs-16 text-primary" }, "segment"),
                  _createElementVNode("span", null, "AI Content Analysis — Block Level (Rincian Blok Teks)")
                ], -1)),
                _createElementVNode("div", _hoisted_150, [
                  _createElementVNode("table", _hoisted_151, [
                    _cache[175] || (_cache[175] = _createElementVNode("thead", { class: "table-light" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          style: {"width":"12%"},
                          class: "text-center"
                        }, "Blok #"),
                        _createElementVNode("th", {
                          style: {"width":"14%"},
                          class: "text-center"
                        }, "Jumlah Kalimat"),
                        _createElementVNode("th", {
                          style: {"width":"14%"},
                          class: "text-center"
                        }, "Jumlah Kata"),
                        _createElementVNode("th", {
                          style: {"width":"16%"},
                          class: "text-center"
                        }, "AI Matched (%)"),
                        _createElementVNode("th", {
                          style: {"width":"14%"},
                          class: "text-center"
                        }, "Status"),
                        _createElementVNode("th", { style: {"width":"25%"} }, "Konteks Catatan"),
                        _createElementVNode("th", {
                          style: {"width":"5%"},
                          class: "text-center"
                        }, "Hapus")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.section_reviews, (sec, idx) => {
                        return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                          _createElementVNode("td", _hoisted_152, [
                            _createElementVNode("div", _hoisted_153, [
                              _cache[170] || (_cache[170] = _createElementVNode("span", { class: "input-group-text px-1 fs-11" }, "Blok", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control form-control-sm text-center px-1",
                                style: {"max-width":"50px"},
                                "onUpdate:modelValue": ($event: any) => ((sec.block_number) = $event)
                              }, null, 8, _hoisted_154), [
                                [
                                  _vModelText,
                                  sec.block_number,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control form-control-sm text-center",
                              "onUpdate:modelValue": ($event: any) => ((sec.sentences_count) = $event),
                              placeholder: "cth: 4"
                            }, null, 8, _hoisted_155), [
                              [
                                _vModelText,
                                sec.sentences_count,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control form-control-sm text-center",
                              "onUpdate:modelValue": ($event: any) => ((sec.words_count) = $event),
                              placeholder: "cth: 96"
                            }, null, 8, _hoisted_156), [
                              [
                                _vModelText,
                                sec.words_count,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_157, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                step: "0.1",
                                class: "form-control form-control-sm text-center",
                                "onUpdate:modelValue": ($event: any) => ((sec.ai_matched_pct) = $event),
                                placeholder: "cth: 100"
                              }, null, 8, _hoisted_158), [
                                [
                                  _vModelText,
                                  sec.ai_matched_pct,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _cache[171] || (_cache[171] = _createElementVNode("span", { class: "input-group-text px-1" }, "%", -1))
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select form-select-sm",
                              "onUpdate:modelValue": ($event: any) => ((sec.status) = $event)
                            }, _cache[172] || (_cache[172] = [
                              _createElementVNode("option", { value: "INCLUDED" }, "INCLUDED", -1),
                              _createElementVNode("option", { value: "EXCLUDED" }, "EXCLUDED", -1)
                            ]), 8, _hoisted_159), [
                              [_vModelSelect, sec.status]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm",
                              "onUpdate:modelValue": ($event: any) => ((sec.context_note) = $event),
                              placeholder: "Konteks / rujukan..."
                            }, null, 8, _hoisted_160), [
                              [_vModelText, sec.context_note]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_161, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeSectionReview(idx)),
                              class: "btn btn-sm btn-outline-danger p-1 border-0"
                            }, _cache[173] || (_cache[173] = [
                              _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "delete", -1)
                            ]), 8, _hoisted_162)
                          ])
                        ]))
                      }), 128)),
                      (_ctx.form.section_reviews.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_163, _cache[174] || (_cache[174] = [
                            _createElementVNode("td", {
                              colspan: "7",
                              class: "text-center text-muted py-3 bg-light-subtle rounded border border-dashed"
                            }, [
                              _createTextVNode(" Belum ada rincian blok teks. Klik "),
                              _createElementVNode("strong", null, "\"Tambah Blok\""),
                              _createTextVNode(" jika ingin merinci blok-blok kalimat yang terdeteksi AI dari laporan Drillbit. ")
                            ], -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_164, [
          _cache[199] || (_cache[199] = _createElementVNode("div", { class: "card-header bg-light d-flex align-items-center gap-2 py-2 px-3" }, [
            _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "gavel"),
            _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "6. Keputusan Terpadu, Validasi & Pengesahan Sertifikat")
          ], -1)),
          _createElementVNode("div", _hoisted_165, [
            _createElementVNode("div", _hoisted_166, [
              _createElementVNode("div", _hoisted_167, [
                _cache[178] || (_cache[178] = _createElementVNode("label", { class: "form-label fs-12 fw-bold text-dark" }, [
                  _createTextVNode("Keputusan Menyeluruh "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.overall_decision) = $event)),
                  required: ""
                }, _cache[177] || (_cache[177] = [
                  _createElementVNode("option", { value: "MEMENUHI" }, "MEMENUHI (Lolos Standar Mutu)", -1),
                  _createElementVNode("option", { value: "REVISI DIANJURKAN" }, "REVISI DIANJURKAN (Melebihi Ambang)", -1),
                  _createElementVNode("option", { value: "KLARIFIKASI DIBUTUHKAN" }, "KLARIFIKASI DIBUTUHKAN", -1),
                  _createElementVNode("option", { value: "ESKALASI KE QC" }, "ESKALASI KE QC", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.overall_decision]
                ])
              ]),
              _createElementVNode("div", _hoisted_168, [
                _cache[179] || (_cache[179] = _createElementVNode("label", { class: "form-label fs-12" }, "Catatan Rekomendasi Terpadu", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.form.recommendation_notes) = $event)),
                  placeholder: "cth: Dokumen memenuhi toleransi similaritas dan tingkat probabilitas AI dalam batas aman."
                }, null, 512), [
                  [_vModelText, _ctx.form.recommendation_notes]
                ])
              ]),
              _createElementVNode("div", _hoisted_169, [
                _createElementVNode("div", _hoisted_170, [
                  _cache[186] || (_cache[186] = _createElementVNode("div", { class: "fw-bold fs-13 mb-2 text-dark d-flex align-items-center gap-1" }, [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-16 text-success" }, "verified"),
                    _createElementVNode("span", null, "Verifikasi 6 Parameter Integritas Akademik")
                  ], -1)),
                  _createElementVNode("div", _hoisted_171, [
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("div", _hoisted_173, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.form.integrity_plagiarism) = $event)),
                          id: "paiIntPlag"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.integrity_plagiarism]
                        ]),
                        _cache[180] || (_cache[180] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "paiIntPlag"
                        }, "Bebas Plagiarisme Substantif", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("div", _hoisted_175, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.form.integrity_fabrication) = $event)),
                          id: "paiIntFab"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.integrity_fabrication]
                        ]),
                        _cache[181] || (_cache[181] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "paiIntFab"
                        }, "Bebas Fabrikasi Data", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_176, [
                      _createElementVNode("div", _hoisted_177, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.integrity_falsification) = $event)),
                          id: "paiIntFals"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.integrity_falsification]
                        ]),
                        _cache[182] || (_cache[182] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "paiIntFals"
                        }, "Bebas Falsifikasi Hasil", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_178, [
                      _createElementVNode("div", _hoisted_179, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.form.integrity_duplicate) = $event)),
                          id: "paiIntDup"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.integrity_duplicate]
                        ]),
                        _cache[183] || (_cache[183] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "paiIntDup"
                        }, "Bebas Redundan / Duplikasi", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_180, [
                      _createElementVNode("div", _hoisted_181, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.form.integrity_authorship) = $event)),
                          id: "paiIntAuth"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.integrity_authorship]
                        ]),
                        _cache[184] || (_cache[184] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "paiIntAuth"
                        }, "Validitas Kepengarangan", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_182, [
                      _createElementVNode("div", _hoisted_183, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.form.integrity_coi) = $event)),
                          id: "paiIntCoi"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.integrity_coi]
                        ]),
                        _cache[185] || (_cache[185] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "paiIntCoi"
                        }, "Bebas Konflik Kepentingan", -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_184, [
                    _createElementVNode("div", _hoisted_185, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.form.integrity_notes) = $event)),
                        placeholder: "Catatan Skrining Integritas Akademik (opsional, cth: Tidak ditemukan indikasi plagiasi substantif)"
                      }, null, 512), [
                        [_vModelText, _ctx.form.integrity_notes]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_186, [
                _cache[187] || (_cache[187] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Nama Penulis (Masked di QR Verifikasi) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.author_name_masked) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.author_name_masked]
                ])
              ]),
              _createElementVNode("div", _hoisted_187, [
                _cache[188] || (_cache[188] = _createElementVNode("label", { class: "form-label fs-12" }, [
                  _createTextVNode("Judul Naskah (Masked di QR Verifikasi) "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.form.document_title_masked) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.document_title_masked]
                ])
              ]),
              _createElementVNode("div", _hoisted_188, [
                _createElementVNode("div", _hoisted_189, [
                  _cache[197] || (_cache[197] = _createElementVNode("h6", { class: "fs-13 fw-bold text-dark mb-2 d-flex align-items-center gap-1" }, [
                    _createElementVNode("span", { class: "material-symbols-outlined fs-18 text-primary" }, "draw"),
                    _createElementVNode("span", null, "Petugas Analis & Penandatangan Pengesahan Protokol")
                  ], -1)),
                  _createElementVNode("div", _hoisted_190, [
                    _createElementVNode("div", _hoisted_191, [
                      _cache[189] || (_cache[189] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, [
                        _createTextVNode("Nama Petugas Pemeriksa / Analis "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.form.examiner_name) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.form.examiner_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_192, [
                      _cache[190] || (_cache[190] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, "Petugas Quality Control (QC)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.form.qc_name) = $event)),
                        placeholder: "Tim QC RBN"
                      }, null, 512), [
                        [_vModelText, _ctx.form.qc_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_193, [
                      _cache[192] || (_cache[192] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, "Pilih Penandatangan Terdaftar", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.form.signatory_id) = $event)),
                        onChange: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.onSignatoryChange && _ctx.onSignatoryChange(...args)))
                      }, [
                        _cache[191] || (_cache[191] = _createElementVNode("option", { value: null }, "-- Gunakan Penandatangan Default --", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatories, (sig) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: sig.id,
                            value: sig.id
                          }, _toDisplayString(sig.name) + " (" + _toDisplayString(sig.position) + ") " + _toDisplayString(sig.is_default ? '★ Default' : ''), 9, _hoisted_194))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.form.signatory_id]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_195, [
                      _cache[193] || (_cache[193] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, "Nama Penandatangan Dokumen", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.form.signatory_name) = $event)),
                        placeholder: "Nama Penandatangan"
                      }, null, 512), [
                        [_vModelText, _ctx.form.signatory_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_196, [
                      _cache[194] || (_cache[194] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, "Jabatan Penandatangan", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.form.signatory_position) = $event)),
                        placeholder: "Direktur PT Raya Berdikari Nusantara"
                      }, null, 512), [
                        [_vModelText, _ctx.form.signatory_position]
                      ])
                    ]),
                    (_ctx.selectedSignatoryPreviewUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                          _createElementVNode("div", _hoisted_198, [
                            _cache[195] || (_cache[195] = _createElementVNode("span", { class: "fs-11 text-muted fw-semibold" }, "Preview Tanda Tangan:", -1)),
                            _createElementVNode("img", {
                              src: _ctx.selectedSignatoryPreviewUrl,
                              alt: "Tanda Tangan",
                              style: {"height":"32px","max-width":"140px","object-fit":"contain"}
                            }, null, 8, _hoisted_199),
                            _cache[196] || (_cache[196] = _createElementVNode("span", { class: "fs-11 text-success d-flex align-items-center gap-1" }, [
                              _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "check_circle"),
                              _createElementVNode("span", null, "Siap disematkan pada sertifikat terpadu RC-PAI")
                            ], -1))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_200, [
                _createElementVNode("div", _hoisted_201, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.form.disclaimer_agreed) = $event)),
                    id: "paiDiscCheck",
                    required: ""
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.disclaimer_agreed]
                  ]),
                  _cache[198] || (_cache[198] = _createElementVNode("label", {
                    class: "form-check-label fs-12 text-secondary",
                    for: "paiDiscCheck"
                  }, " Saya menyetujui seluruh parameter pengujian dan memastikan data audit trail sesuai dengan hasil software resmi Drillbit Plagiarism & AI. ", -1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_202, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary px-4 py-2 d-flex align-items-center gap-2",
            disabled: _ctx.submitting
          }, [
            (_ctx.submitting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_204))
              : _createCommentVNode("", true),
            _cache[200] || (_cache[200] = _createElementVNode("span", { class: "material-symbols-outlined fs-18" }, "save", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.protocol ? 'Perbarui Protokol RC-PAI' : 'Simpan & Terbitkan Protokol RC-PAI'), 1)
          ], 8, _hoisted_203)
        ])
      ], 32)
    ])
  ]))
}